import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { AemConfigurationContext } from '@as-react/common-components';
import { Poller } from '@as-react/common-utils';
import { bindActionCreators } from 'redux';
import { Rental } from '../components/rental/Rental';
import { authActions } from '../redux/authentication/actions/AuthActions.creators';
const initialState = {
    ready: false,
};
const jQuery = '$';
class RentalContainer extends PureComponent {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            // wait for jQuery datepicker
            this.waitForScript();
        };
        this.waitForScript = () => __awaiter(this, void 0, void 0, function* () {
            const scriptPoll = new Poller(() => (window && window[jQuery] && window[jQuery]().datepicker ? true : false), 500);
            yield scriptPoll.run();
            this.setReady();
        });
        this.setReady = () => {
            this.setState({
                ready: true,
            });
        };
        this.state = initialState;
    }
    render() {
        const { ready } = this.state;
        return (_jsx(AemConfigurationContext.Consumer, { children: configuration => {
                const { defaultRequestParams, servicesEndpoint } = configuration;
                if (ready) {
                    return (_jsx(Rental, { apiPrefix: servicesEndpoint, defaultRequestParams: defaultRequestParams, onLogout: this.props.onLogout }));
                }
                return null;
            } }));
    }
}
const mapDispatchToProps = dispatch => bindActionCreators({
    onLogout: authActions.logout,
}, dispatch);
const makeMapStateToProps = () => {
    const mapStateToProps = state => ({});
    return mapStateToProps;
};
export default connect(makeMapStateToProps, mapDispatchToProps)(RentalContainer);
